import {request} from './request'

//国家列表
export function getCountryList(){
    return request({
        url:"/country/listForSelect",
        method:'post'
    })
}

//院校列表
export function getSchoolList(data){
    return request({
        url:"/school/listForSelect",
        method:'post',
        data
    })
}

//根据院校id获取申请条件
export function getApplylList(id){
    return request({
        url:"/apply-condition/getList/" + id,
        method:'post'
    })
}
// 提交报名信息生成订单
export function order(data){
    return request({
        url:"/order/add",
        method:'post',
        data
    })
}

// 文件上传
export function upLoad(data){
    return request({
        url:"/upload",
        method:'post',
        headers:{
            'Content-Type':'multipart/form-data'
        },
        data
    })
}

// 个人订单列表
export function orderList(data){
    return request({
        url:"order/personalList",
        method:'post',
        data
    })
}

// 订单详情
export function orderDetail(id){
    return request({
        url:"order/get/" + id,
        method:'post'
    })
}

//修改单个申请文件
export function updataFile(id,data){
    return request({
        url:'/order/fileUpdate/' + id,
        method:'post',
        data
    })
}

// 订单修改
export function changeOrder(data){
    return request({
        url:"/order/update",
        method:'post',
        data
    })
}

// 更新用户信息
export function updateInfo(data){
    return request({
        url:"/wx-user/updateInfo",
        method:'post',
        data
    })
}

// 检查微信用户真实姓名和手机号码是否填写
export function checkRealName(){
    return request({
        url:"/wx-user/checkRealName",
        method:'post',
    })
}

// 统一下单获取支付二维码
export function payOrder(data){
    return request({
        url:"/wx-pay/unifiedOrder",
        method:'post',
        data
    })
}

// 查询订单支付情况
export function queryOrder(data){
    return request({
        url:"/wx-pay/queryOrder",
        method:'post',
        data
    })
}